import {
  createReqConsts,
  createActions,
  createReqWatcher,
  initialState as rootState,
  makePaginationReducer,
} from '../../../utils/redux';

const makeMedicationsReqConfig = (slug = []) => ({
  endpoint: 'users',
  type: 'get',
  slug: [
    {
      type: 'payload',
      selector: ['userId'],
    },
    'appointments',
    'available_medications',
    'ndc_drugs',
    {
      type: 'payload.query',
      queryParameter: 'query',
      selector: 'query',
    },
    {
      type: 'payload.query',
      queryParameter: 'limit',
      selector: 'limit',
    },
    ...slug,
  ],
});

const requestOptions = makeMedicationsReqConfig([
  {
    type: 'payload.query',
    queryParameter: 'offset',
    selector: 'offset',
  },
]);

export const consts = createReqConsts('appointment-form', 'medications-req', [
  'LOAD_MORE',
]);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, requestOptions, true);

export const paginationConsts = createReqConsts(
  'appointment-form',
  'medications-req-lazy-load',
);
export const paginationActions = createActions(paginationConsts);
export const paginationWatcher = createReqWatcher(
  paginationConsts,
  paginationActions,
  requestOptions,
  true,
);

const defaultRequestReducer = makePaginationReducer({
  consts,
  paginationConsts,
  counterKey: 'total',
});

const initialState = {
  ...rootState,
};

export default (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case consts.SUCCEED:
      const safeData = payload.map(medication => ({
        value: {
          id: medication.ndcDrugId,
          name: medication.displayableName,
        },
        label: medication.displayableName,
      }));

      return {
        ...state,
        succeed: true,
        sending: false,
        isLastPage: payload && !payload.length,
        list:
          state.list && state.list.length !== 0
            ? state.list.concat(safeData)
            : safeData,
      };

    default:
      return defaultRequestReducer(state, action);
  }
};



// WEBPACK FOOTER //
// ./src/redux/appointmentForm/requests/medications-req.js